import React, { useContext, useState } from 'react'
import AuthContext from '../../context/auth/authContext'
import SubmitForm from './SubmitForm'
import Inputmask from 'inputmask'
import toastr from 'toastr'
import $ from 'jquery';

function Step8({ validateField }) {
    setTimeout(() => {
        const arr = document.querySelectorAll('[data-inputmask]');
        Inputmask({ 'placeholder': '' }).mask(arr);
    }, 500);
    const authContext = useContext(AuthContext);
    let { lead, gotoNextStep, step } = authContext;
    const initialState = {
        business_bank_name: lead.business_bank_name ?? null,
        business_bank_routing_nr: lead.business_bank_routing_nr ?? null,
        business_bank_account_nr: lead.business_bank_account_nr ?? null,
        business_federal_tax_id: lead.business_federal_tax_id ?? null,
        ssn: lead.owners[0].ssn ?? null,
        secured: true,
        has_fid: lead.has_fid
    }
    const { owners } = lead;
    const [fields, setFields] = useState(initialState);
    const handleChange = (event) => {
        const target = event.target;
        let value = target.value;
        let index = target.name;
        validateField(target);
        // console.log(value,index);
        if (index === 'has_fid') {
            $('#fid_col').removeClass('is-invalid');
            if (value === 0) {
                setFields({
                    ...fields, business_federal_tax_id: '', [index]: value
                });
            } else {
                setFields({
                    ...fields, [index]: value
                });
            }
            handleShowField(target);
        } else {
            setFields({
                ...fields, [index]: value
            });

        }
    }
    const handleFields = () => {
        setFields({
            ...fields, secured: !fields.secured
        });
    }
    const handleSubmit = (event) => {
        event.preventDefault();
        const $array = Object.keys(fields);
        const $errorbag = [];
        $array.map((item) => {
            const target = document.getElementsByName(item)[0];
            if (target) {
                let $result = validateField(target);
                if ($result) {
                    $errorbag.push($result);
                }
            }
            return null;
        });
        if ($errorbag.length === 0) {
            gotoNextStep(fields, step);
        } else {
            let $format = '';
            $errorbag.map((error, i) => {
                const $err = error + '<br/>';
                $format += $err;
                return null;
            })
            toastr.error($format);
        }
    }
    const handleShowField = (event) => {
        let $el = $(event);
        if ($el.hasClass('secured')) {
            if ($el.attr('timeout')) {
                clearTimeout($el.attr('timeout'));
                $el.removeAttr('timeout');
            }
            // $el.attr('type', 'tel');
            $el.removeClass('secured');
            let $timeout = setTimeout(() => {
                // $el.attr('type', 'password');
                $el.addClass('secured');

            }, 1500);
            $el.attr('timeout', $timeout);


        }
    }


    return (
        <>
            <form onSubmit={e => handleSubmit(e)} autoComplete="off">
                <p className="text-center mb-0">
                    <button type="button" className="btn btn-sm btn-primary" onClick={e => handleFields(e)} title="Show/Hide fields">
                        <i className={fields.secured ? 'fa fa-eye' : 'fa fa-eye-slash'}></i> {fields.secured ? 'Show secured fields' : 'Hide secured fields'}
                    </button>
                </p>
                <div className="container">
                    <div className="row">
                        <div className="mb-3 col-md-12">
                            <label htmlFor="business_bank_name">Bank Name</label>
                            <div className="input-group">
                                <span className="input-group-text"><i className="fas fa-map-pin"></i></span>
                                <input type="text" name="business_bank_name" onChange={e => handleChange(e)}
                                    className="form-control"
                                    value={fields.business_bank_name || ''} />
                            </div>
                        </div>
                        <div className="mb-3 col-md-6">
                            <label htmlFor="business_bank_routing_nr">Bank Routing Number:</label>
                            <div className="input-group">
                                <span className="input-group-text"><i className="fas fa-hashtag"></i></span>
                                <input type='tel' inputMode="numeric" name="business_bank_routing_nr" placeholder='xxxxxxxxx' data-inputmask="'mask': '999999999'"
                                    onChange={e => handleChange(e)}
                                    className={'form-control ' + (fields.secured ? "secured" : '')}
                                    value={fields.business_bank_routing_nr || ''} />
                            </div>
                        </div>
                        <div className="mb-3 col-md-6">
                            <label htmlFor="business_bank_account_nr">Bank Account Number:</label>
                            <div className="input-group">
                                <span className="input-group-text"><i className="fas fa-hashtag"></i></span>
                                <input type='tel' inputMode="numeric" name="business_bank_account_nr" placeholder="xxxxxxxxxx" onChange={e => handleChange(e)}
                                    className={'form-control ' + (fields.secured ? "secured" : '')}
                                    value={fields.business_bank_account_nr || ''} />
                            </div>
                        </div>
                        {owners.map((owner, index) => {
                            if (owner) {
                                return (
                                    <div key={owner.id} className="mb-3 col-md-6">
                                        <label htmlFor="ssn" >Owner SSN</label>
                                        <div className="input-group">
                                            <span className="input-group-text"><i className="far fa-address-card"></i></span>
                                            <input
                                                type="tel"
                                                inputMode="numeric"
                                                name="ssn"
                                                placeholder="Social Security Number"
                                                className={'form-control custom_field ' + (fields.secured ? "secured" : '')}
                                                data-inputmask="'mask': '999-99-9999'"
                                                value={fields.ssn || ''} onChange={e => handleChange(e)} />
                                        </div>
                                        <p className="small pb-0 mb-0">*This allows us to validate your information</p>

                                    </div>
                                )
                            }
                            return null;
                        })}
                        <div className="mb-3 col-md-6" id="fid_col">
                            {lead.business_ownership === 'Sole Proprietorship' ?
                                <>
                                    <label htmlFor="">Do You have Federal Tax ID #?</label>
                                    <div className="form-group">
                                        <div className="btn-group btn-group-toggle d-block" data-toggle="buttons">
                                            <label
                                                className={"btn btn-light bg-button " + (fields.has_fid == 1 ? 'active' : '')}>
                                                <input type="radio"
                                                    onChange={e => handleChange(e)}
                                                    value="1"
                                                    defaultChecked={fields.has_fid == 1 ? true : false}
                                                    className="has_fid"
                                                    name="has_fid" id="option1" /> Yes
                                            </label>
                                            <label className={"btn  btn-light bg-button " + (fields.has_fid == 0 ? 'active' : '')}>
                                                <input type="radio" value="0" onChange={e => handleChange(e)} defaultChecked={fields.has_fid == 0 ? true : false} className="has_fid" name="has_fid" id="option2" /> No  </label>
                                        </div>
                                    </div>
                                    {fields.has_fid == 1 ?
                                        <div className={fields.has_fid == 1 ? "d-block" : "d-none"} >
                                            <div className="input-group">
                                                <span className="input-group-text"><i className="fas fa-hashtag"></i></span>
                                                <input
                                                    type='tel'
                                                    autoComplete="off"
                                                    name="business_federal_tax_id"
                                                    onChange={e => handleChange(e)}
                                                    className={'form-control ' + (fields.secured ? "secured" : '')}
                                                    data-inputmask="'mask': '999999999'"
                                                    placeholder='xxxxxxxxx'
                                                    inputMode="numeric"
                                                    data-required={lead.business_ownership === 'Sole Proprietorship' && fields.has_fid === 'No' ? 'false' : 'true'}
                                                    value={fields.business_federal_tax_id || ''} />
                                            </div>
                                            <p className="small pb-0 mb-0">*This allows us to validate your business information</p>

                                        </div>
                                        :
                                        <p className="small pb-0 mb-0">*If you're not sure, select No</p>
                                    }

                                </>
                                : <>
                                    <label htmlFor="">Federal Tax ID #</label>

                                    <div className="input-group">
                                        <span className="input-group-text"><i className="fas fa-hashtag"></i></span>
                                        <input
                                            type="tel"
                                            autoComplete="off"
                                            name="business_federal_tax_id"
                                            onChange={e => handleChange(e)}
                                            className={'form-control ' + (fields.secured ? "secured" : '')}
                                            inputMode="numeric"
                                            data-inputmask="'mask': '999999999'"
                                            placeholder='xxxxxxxxx'
                                            data-required={lead.business_ownership === 'Sole Proprietorship' && fields.has_fid === 'No' ? 'false' : 'true'}
                                            value={fields.business_federal_tax_id || ''} />
                                    </div>
                                    <p className="small pb-0 mb-0">*This allows us to validate your business information</p>

                                </>
                            }

                        </div>

                    </div>

                    <SubmitForm />
                </div >

            </form >
        </>
    )
}

export default Step8
